import { useMemo } from 'react'
import { GetProgramLevelFromHashmap } from 'functions/programLevelUtils'

import ExerciseCollectionCycleExercise from 'components/ExerciseCollection/ExerciseCollectionCycleExercise'

const DISPLAY_EXERCISE_COLLECTION_CYCLE_PROGRAM_LEVEL_SCORE_RANGE = false

export default function ExerciseCollectionCycle({
    exerciseHashMap = {},
    programLevelHashMap = {},
    exerciseCollection = {},
    setExerciseCollection = () => {},
    requireProgramLevelTagging = 0,
    exerciseCollectionCycleIndex = 0,
    exerciseCollectionCycle = {},
    allowEditing = false,
    highlightedExerciseId = null,
    highlightInjuryOverrides = false,
}) {

    const exerciseCollectionCycleExercises = exerciseCollectionCycle?.exerciseCollectionCycleExercises ?? []
    const cyclesAssigned = Number(exerciseCollectionCycle?.cyclesAssigned ?? 1)
    const programLevelScoreLowerBound = Number(exerciseCollectionCycle?.programLevelScoreLowerBound ?? 0)
    const programLevelScoreUpperBound = Number(exerciseCollectionCycle?.programLevelScoreUpperBound ?? 0)
    const exerciseCollectionCycleProgramLevel = useMemo(() => GetProgramLevelFromHashmap(programLevelHashMap, programLevelScoreUpperBound), [programLevelHashMap, programLevelScoreUpperBound])
    const exerciseCollectionCyclesOnlyContainsOneExercise = cyclesAssigned === 1 && exerciseCollectionCycleExercises.length === 1
    const fillPercent = 0
    const label = `${0}/${cyclesAssigned} cycles`

    return (
        <div className='space-y-2'>
            <div className="flex-shrink-0 flex flex-col">
                <div className="flex gap-x-2 overflow-x-auto [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300">
                    {exerciseCollectionCycleExercises.map((exerciseCollectionCycleExercise, exerciseCollectionCycleExerciseIndex) => (
                        <ExerciseCollectionCycleExercise
                            key={exerciseCollectionCycleExerciseIndex}
                            exerciseHashMap={exerciseHashMap}
                            programLevelHashMap={programLevelHashMap}
                            exerciseCollection={exerciseCollection}
                            setExerciseCollection={setExerciseCollection}
                            requireProgramLevelTagging={requireProgramLevelTagging}
                            exerciseCollectionCycleIndex={exerciseCollectionCycleIndex}
                            exerciseCollectionCycleExerciseIndex={exerciseCollectionCycleExerciseIndex}
                            exerciseCollectionCycleExercise={exerciseCollectionCycleExercise}
                            allowEditing={allowEditing}
                            highlightedExerciseId={highlightedExerciseId}
                            highlightInjuryOverrides={highlightInjuryOverrides}
                        />
                    ))}
                </div>
            </div>

            {DISPLAY_EXERCISE_COLLECTION_CYCLE_PROGRAM_LEVEL_SCORE_RANGE && requireProgramLevelTagging === 1 && (
                <div
                    className='rounded-full'
                    style={{
                        backgroundColor: exerciseCollectionCycleProgramLevel?.colorHex,
                    }}
                >
                    <p className='text-xxs text-center'>
                        {programLevelScoreLowerBound}-{programLevelScoreUpperBound}</p>
                </div>
            )}

            {!exerciseCollectionCyclesOnlyContainsOneExercise && (
                <div className='relative h-4 w-full overflow-hidden rounded-full bg-gray-300'>
                    <div
                        className='absolute inset-y-0 left-0 bg-orange-400'
                        style={{ width: `${fillPercent}%` }}
                    />

                    <p className='relative z-10 flex h-full items-center justify-center text-[10px] font-bold text-gray-700'>
                        {label}
                    </p>

                    {fillPercent > 0 &&
                        <div
                            className='absolute inset-y-0 left-0 z-20 overflow-hidden'
                            style={{ width: `${fillPercent}%` }}
                        >
                            <p
                                className='flex h-full items-center justify-center text-[10px] font-bold text-white'
                                style={{ width: `${10000 / fillPercent}%` }}
                            >
                                {label}
                            </p>
                        </div>
                    }
                </div>
            )}
        </div>
    )
}